import React from 'react'
import IconButton from '@mui/material/IconButton'
import { J1DownarrowD } from '@e3dc-react/icons'
import { DropdownIndicatorProps, components } from 'react-select'
import { makeStyles } from 'tss-react/mui'

const useSelectStyles = makeStyles()(theme => ({
  indicator: {
    paddingRight: `${theme.spacing(1)} !important`,
  },
  button: {
    padding: 0,
  },
}))

/**
 * This component displays a dropdown indicator (arrow) typically used by select components
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DropdownIndicator = (props: DropdownIndicatorProps<any, any>): React.ReactElement => {
  const { classes } = useSelectStyles()

  return (
    <components.DropdownIndicator {...props} className={classes.indicator}>
      <IconButton className={classes.button} disabled={props.isDisabled}>
        <J1DownarrowD />
      </IconButton>
    </components.DropdownIndicator>
  )
}

export default DropdownIndicator
